/**
 * Created by Dhanya Akhil on 3/1/2017.
 */
import {Component, OnInit} from '@angular/core';
import {FormControl,FormBuilder, FormGroup,FormArray,Validators, AbstractControl} from '@angular/forms';
import {SendForgotPasswordService} from '../services/send-forgotpassword.service';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';

@Component({
  selector: 'app-userlock',
  templateUrl: './send-forgotpassword.component.html',
  styleUrls: ['./send-forgotpassword.component.css']
})
export class SendForgotPasswordComponent implements OnInit {
  success;
  error;
  data;

  errorMessage:string = "Server Error";
  language:string;
  public lang;
  public browserLang;
  doNotMatch = false;
  message;
  public users;
  public totalItems;
  public currentPage = 1;
  public pageNumber;
  public pageSize;
  public unlockId;
  public noData:boolean = false;
  public dataAvailable:boolean = false;
  public numPages:number = 0;
  public reqStatus ='';
  errorERRFP000001:any = false;
  errorERRFP000002;
  errorERRFP000003;
  errorERRFP000004;
  errorERRFP000005;
  public allStatus = [
    {
      'name' : "All",
      'value' : ''
    },{
      'name' : "Request",
      'value' : '1'
    },{
      'name' : "Not Request",
      'value' : '0'
    }];
  public userSearchForm = new FormGroup({
    'employeeId': new FormControl('', Validators.required),
    'certificateNumber' : new FormControl('', Validators.required),
    'status': new FormControl('')
  });
  public employeeId: AbstractControl = this.userSearchForm.get('employeeId');
  public certificateNumber: AbstractControl = this.userSearchForm.get('certificateNumber');
  public status: AbstractControl = this.userSearchForm.get('status');

  constructor(public userService:SendForgotPasswordService,private translate:TranslateService) {
    this.lang = translate.currentLang;

    this.translate.onLangChange.subscribe((event:LangChangeEvent) => {
      this.browserLang = event.lang
      this.lang = this.browserLang;
    });
  }


  ngOnInit() {
    this.employeeId.patchValue('');
    this.certificateNumber.patchValue('');
    this.status.patchValue('');
    this.pageNumber = 1;
    this.pageSize = 10;
    this.getuser();
  }
  public resetForgotPasswordErrors() {
    this.error = false;
    this.errorERRFP000001 = false;
    this.errorERRFP000002 = false;
    this.errorERRFP000003 = false;
    this.errorERRFP000004 = false;
    this.errorERRFP000005 = false;
  }

  public getuser(){
    this.userService.getUser(this.employeeId.value,this.certificateNumber.value,this.status.value,this.pageNumber,this.pageSize)
      .subscribe(
        (response) => {
          this.error = false;
          this.noData = false;
          this.users = response['content'];
          if(response['content'].length == 0){
            this.noData = true;
            this.dataAvailable = false;
          } else {
            this.noData = false;
            this.dataAvailable = true;
          }
         this.totalItems = response['totalElements'];
        },
        (error) => {
          this.error = true;
        }
      );
  }
  sendForgotPassword(unlockId) {
    this.error = false;
    this.success = false;
    this.userService.sendForgotPassword(unlockId).subscribe(
      data => {
        this.data = data;
        if (this.data.status == 200) {
          this.resetForgotPasswordErrors();
          this.success = true;
          this.message = this.data.message;
          this.pageNumber = 1;
          this.pageSize = 10;
          this.getuser();
        } else {
          this.success = null;
          this.resetForgotPasswordErrors();
          if (this.data.status !== null || this.data.status !== undefined) {
            this['error' + this.data.status] = true;
            this.message = this.data.message;
          } else {
            this.error = 'ERROR';
            this.message = this.data.message;
          }
        }
      },
      error => this.errorMessage = <any>error);

  }
  public pageChanged(event: any): void {
    this.pageNumber = event.page;
    this.pageSize = event.itemsPerPage;
    this.getuser();
  }
  public clearSearchData() {
    if (this.employeeId.value == '' || this.certificateNumber.value == '' || this.status.value){
      this.employeeId.patchValue('');
      this.certificateNumber.patchValue('');
      this.status.patchValue('');
      this.pageNumber = 1;
      this.pageSize = 10;
      this.getuser();
    }
  }

}
